module.exports = __webpack_public_path__ + "img/comic8.jpg";